import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c1f12f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-content" }
const _hoisted_2 = {
  key: 0,
  class: "auto-sync-hint"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "自動更新中 (10s)", -1))
const _hoisted_4 = { class: "search-container" }
const _hoisted_5 = { class: "filter-container" }
const _hoisted_6 = {
  key: 0,
  class: "cards-grid"
}
const _hoisted_7 = { class: "skeleton-header" }
const _hoisted_8 = { class: "skeleton-footer" }
const _hoisted_9 = {
  key: 1,
  class: "content-wrapper"
}
const _hoisted_10 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-icon" }, "🍣", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "找不到相關分店", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "請嘗試其他關鍵字或切換至「全部」地區", -1))
const _hoisted_14 = [
  _hoisted_11,
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  class: "section-block"
}
const _hoisted_16 = { class: "section-title" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title-accent" }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "已釘選的分店", -1))
const _hoisted_19 = { class: "badge" }
const _hoisted_20 = { class: "cards-grid" }
const _hoisted_21 = { class: "section-block" }
const _hoisted_22 = {
  key: 0,
  class: "section-title"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title-accent gray" }, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "所有分店", -1))
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = { class: "cards-grid" }

import {
  IonContent,
  IonHeader,
  IonPage,
  IonRefresher,
  IonRefresherContent,
  IonTitle,
  IonToolbar,
  IonSearchbar,
  IonSegment,
  IonSegmentButton,
  IonLabel,
  IonIcon,
  IonSkeletonText
} from '@ionic/vue';
import { syncOutline } from 'ionicons/icons';
import { ref, onMounted, computed, Ref } from 'vue';
import { getStoreList, getAllQueue } from '@/data/getData';
import StoreCard from '@/components/StoreCard.vue';
import { Store, Queue } from '@/data/classes';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

/* eslint-disable */
const stores: Ref<Store[]> = ref([]);
const content = ref<any>(null);
const initLoading = ref<boolean>(true);
const searchQuery = ref<string>('');
const selectedArea = ref<string>('all');

// 使用 const 定義 Ref 物件，避免 ESLint prefer-const 錯誤
const bookmarkIndexes = ref<Set<number>>(new Set());
let interval: any = null;

onMounted(async () => {
  await loadData();
});

async function loadData() {
  stores.value = await getStoreList();
  if (stores.value.length > 0) {
    const allQueue = await getAllQueue(stores.value);
    if (allQueue && Array.isArray(allQueue.data)) {
      (allQueue.data as Queue[]).forEach((queue) => {
        const index = stores.value.findIndex((s) => s.id === queue.storeId);
        if (index !== -1) {
          stores.value[index].queue = queue.data as number[];
        }
      });
    }
  }
  initLoading.value = false;
}

async function handleManualRefresh(event: any) {
  await loadData();
  if (event && event.target) {
    event.target.complete();
  }
}

const handleToggleBookmark = (id: number) => {
  const index = stores.value.findIndex((s) => s.id === id);
  if (index === -1) return;

  stores.value[index].isBookmark = !stores.value[index].isBookmark;
  if (stores.value[index].isBookmark) {
    bookmarkIndexes.value.add(index);
  } else {
    bookmarkIndexes.value.delete(index);
  }
  autoUpdateQueue();
};

const autoUpdateQueue = () => {
  if (interval && bookmarkIndexes.value.size === 0) {
    clearInterval(interval);
    interval = null;
  }
  if (bookmarkIndexes.value.size > 0 && !interval) {
    interval = setInterval(() => {
      bookmarkIndexes.value.forEach((index: number) => {
        if (stores.value[index]) {
          stores.value[index].getQueue();
        }
      });
    }, 10000);
  }
};

// 篩選運算
const bookmarkedStores = computed(() => stores.value.filter((s) => s.isBookmark));
const bookmarkedStoresCount = computed(() => bookmarkedStores.value.length);

const filteredStores = computed(() => {
  return stores.value.filter((store) => {
    // 搜尋比對
    const query = searchQuery.value.trim().toLowerCase();
    const matchSearch =
      !query ||
      store.name.toLowerCase().includes(query) ||
      store.address.toLowerCase().includes(query) ||
      (store.area && store.area.toLowerCase().includes(query));

    // 標籤頁比對
    let matchArea = true;
    if (selectedArea.value === 'bookmark') {
      matchArea = store.isBookmark;
    } else if (selectedArea.value !== 'all') {
      matchArea = store.area?.includes(selectedArea.value) || store.address.includes(selectedArea.value);
    }

    return matchSearch && matchArea;
  });
});

const regularDisplayStores = computed(() => {
  if (selectedArea.value === 'all' && !searchQuery.value) {
    return filteredStores.value.filter((s) => !s.isBookmark);
  }
  return filteredStores.value;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), { class: "ion-no-border main-header" }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                (bookmarkIndexes.value.size > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createVNode(_unref(IonIcon), {
                        icon: _unref(syncOutline),
                        class: "spinning-icon"
                      }, null, 8, ["icon"]),
                      _hoisted_3
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_unref(IonTitle), { size: "large" }, {
                default: _withCtx(() => [
                  _createTextVNode("香港壽司郎籌號")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(IonSearchbar), {
              modelValue: searchQuery.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
              placeholder: "搜尋分店名稱、商場或地址...",
              debounce: 150,
              animated: true,
              class: "custom-searchbar"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_unref(IonSegment), {
              modelValue: selectedArea.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedArea).value = $event)),
              mode: "ios",
              scrollable: true
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonSegmentButton), { value: "all" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), null, {
                      default: _withCtx(() => [
                        _createTextVNode("全部 (" + _toDisplayString(stores.value.length) + ")", 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonSegmentButton), { value: "bookmark" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), null, {
                      default: _withCtx(() => [
                        _createTextVNode("⭐️ 收藏 (" + _toDisplayString(_unref(bookmarkedStoresCount)) + ")", 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonSegmentButton), { value: "九龍" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), null, {
                      default: _withCtx(() => [
                        _createTextVNode("九龍")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonSegmentButton), { value: "新界" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), null, {
                      default: _withCtx(() => [
                        _createTextVNode("新界")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonSegmentButton), { value: "香港島" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), null, {
                      default: _withCtx(() => [
                        _createTextVNode("港島")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), {
        fullscreen: true,
        ref_key: "content",
        ref: content,
        class: "main-content"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonRefresher), {
            slot: "fixed",
            onIonRefresh: handleManualRefresh
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonRefresherContent), {
                "pulling-text": "下拉即刻更新籌號...",
                "refreshing-spinner": "crescent"
              })
            ]),
            _: 1
          }),
          (initLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (n) => {
                  return _createElementVNode("div", {
                    key: n,
                    class: "skeleton-card"
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_unref(IonSkeletonText), {
                        animated: true,
                        style: {"width":"50%","height":"22px","border-radius":"6px"}
                      }),
                      _createVNode(_unref(IonSkeletonText), {
                        animated: true,
                        style: {"width":"24px","height":"24px","border-radius":"50%"}
                      })
                    ]),
                    _createVNode(_unref(IonSkeletonText), {
                      animated: true,
                      style: {"width":"80%","height":"14px","margin-top":"10px"}
                    }),
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_unref(IonSkeletonText), {
                        animated: true,
                        style: {"width":"40%","height":"36px","border-radius":"8px"}
                      }),
                      _createVNode(_unref(IonSkeletonText), {
                        animated: true,
                        style: {"width":"45%","height":"36px","border-radius":"8px"}
                      })
                    ])
                  ])
                }), 64))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (_unref(filteredStores).length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_14))
                  : _createCommentVNode("", true),
                (selectedArea.value === 'all' && _unref(bookmarkedStores).length > 0 && !searchQuery.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _hoisted_18,
                        _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(bookmarkedStores).length), 1)
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bookmarkedStores), (store) => {
                          return (_openBlock(), _createBlock(StoreCard, {
                            key: 'bm-' + store.id,
                            store: store,
                            onToggleBookmark: handleToggleBookmark
                          }, null, 8, ["store"]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_21, [
                  (selectedArea.value === 'all' && !searchQuery.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_25))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_26, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(regularDisplayStores), (store) => {
                      return (_openBlock(), _createBlock(StoreCard, {
                        key: store.id,
                        store: store,
                        onToggleBookmark: handleToggleBookmark
                      }, null, 8, ["store"]))
                    }), 128))
                  ])
                ])
              ]))
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }))
}
}

})